import { DropdownMenuCheckboxItem } from "@/components/ui/dropdown-menu"
import { useContext } from "react";
import { ToolsContext } from "../playground-main";

export const AgentToolItem = ({ icon, label, id }: { icon: JSX.Element; label: string; id: string }) => {
  const value = useContext(ToolsContext);
  return <DropdownMenuCheckboxItem onCheckedChange={() => {
    if (value?.setTools) {
      if (value?.tools.find(tool => tool == id)) {
        value.setTools(value?.tools.filter(tool => tool !== id))
      } else {
        value.setTools(prev => [...prev, id])
      }
    }
  }} checked={!!value?.tools.find(tool => tool === id)}>
    {icon}
    <p className="text-accent-foreground text-[12px]">{label}</p>
  </DropdownMenuCheckboxItem>
}
